import { Col, Container, Row } from 'react-bootstrap';
import React, { ChangeEvent, useEffect, useState } from "react";
import DefaultCard from '../../components/DefaultCard';
import GenericCard from '../../components/GenericCards/GenericCards';
import CustomSelect from '../../components/Select';
import YTD from '../../components/AccountHistoryRanges/YTD';
import TM from '../../components/AccountHistoryRanges/TM';
import RK from '../../components/AccountHistoryRanges/RK';
import CR from '../../components/AccountHistoryRanges/CR';
import SDR from '../../components/AccountHistoryRanges/SDR';

import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../utils/utils';




const optionsPlans = [{ value: '1', label: 'Cash Balance Plan' }];

const optionsAsOf = [
    { value: '1', label: 'Last Recordkeeping Cycle' },
    { value: 'ytd', label: 'Year to Date' },
    { value: 'tm', label: 'Last 12 Months' },
    { value: '4', label: 'Custom' }
];





const transactionDateRange = [
  {
    transactionType: 'Year to Date',
    startingBalance: '$47,001.77',
    payCredits: '$5,741.78',
    interestCredits: '$1,849.07',
    endingBalance: '$54,592.62',
  },

];

const transactionTableData = [
  {
    requestedDate: '09/01/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Hardship Withdrawal',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -2),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Change Contributions',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -365),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Pension Election',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -730),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Contribution Change',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Rebalance Funds',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Remove Direct Deposit',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Investment Direction',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Home Loan',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Withdrawal',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Pension Direct Deposit',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Withdrawal Rollover',
    endingBalance: '$107,562.39',
  },
];

const today = new Date();

const currentYear = new Date().getFullYear();

const startDate = new Date(currentYear, 0, 1);

const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

const formattedStartDate = formatDate(
  startDate,
  DateFormats.SHORT_MONTH_DAY_YEAR
);
const formattedStartDateUS = formatDate(startDate, DateFormats.US);
const formattedEndDate = formatDate(endDate, DateFormats.SHORT_MONTH_DAY_YEAR);
const formattedEndDateUS = formatDate(endDate, DateFormats.US);

const AccountActivity = () => {


     
const [inputValue, setInputValue] = useState("sdr");

const [sdrContentVisible, setSDRContentVisible] = useState(true);
const [ytdContentVisible, setYTDContentVisible] = useState(false);
const [tmContentVisible, setTMContentVisible] = useState(false);
const [rkContentVisible, setRKContentVisible] = useState(false);
const [crContentVisible, setCRContentVisible] = useState(false);


  useEffect(() => {
    inputValue === "sdr" ? setSDRContentVisible(true) : setSDRContentVisible(false);
    inputValue === "ytd" ? setYTDContentVisible(true) : setYTDContentVisible(false);
    inputValue === "tm" ? setTMContentVisible(true) : setTMContentVisible(false);
    inputValue === "rk" ? setRKContentVisible(true) : setRKContentVisible(false);
    inputValue === "cr" ? setCRContentVisible(true) : setCRContentVisible(false);
  }, 
  [inputValue]);

   const handleOnChange = (e : ChangeEvent<HTMLSelectElement>) => {
    setInputValue(e.target.value);
  };


  return (


    <Container className={'cnd-custom-container mt-11 mb-3'}>

      <Row className={'align-items-center'}>
        <Col className={'col-12 col-lg-4 mb-10 mb-lg-0'}>
          <h2 className={'text-sm-20-lg-32'}>Account History</h2>
          <span className={'text-fs-6 text-light-grey fw-light'}>
            {formattedStartDate} - {formattedEndDate}
          </span>
        </Col>
        <Col className={'col-12 col-lg-4 mb-7 mb-lg-0'}>
          <CustomSelect
            options={optionsPlans}
            placeholder={'Cash Balance Plan'}
          />
        </Col>
        <Col className={'col-12 col-lg-4 mb-7 mb-lg-0'}>
         <select className="form-select selectDateRange" value={inputValue} onChange={handleOnChange} placeholder={'Select Date Range'}>
         <option value="sdr" selected>Select Date Range</option> 
         <option value="rk">Last Recordkeeping Cycle</option>
          <option value="ytd">Year to Date</option>
          <option value="tm">Last 12 Months</option>
          <option value="cr">Custom</option>
        </select>

        </Col>
      </Row>
      
      {<SDR /> && sdrContentVisible}

      {sdrContentVisible && <SDR />}
      {rkContentVisible && <RK />}
      {ytdContentVisible && <YTD />}
      {tmContentVisible && <TM />}
      {crContentVisible && <CR />}
   
    </Container>
  );
};

export default AccountActivity;
